<template>
  <div>
    <v-dialog v-model="dialogoAlert" persistent max-width="480">
      <v-alert
        dense
        border="left"
        type="warning"
        class="mb-0"
        icon="mdi-alert"
        v-model="dialogoAlert"
        dismissible
        @input="dialogoAlert = false"
      >
        La fecha inicial <strong>no puede ser posterior</strong> a la fecha de
        fin.
        <br />
        Por favor elija
        <strong>una fecha final posterior al {{ fechaInicio }}</strong
        >.
      </v-alert>
    </v-dialog>
    <v-row class="mt-4 mb-2">
      <v-col cols="12" v-if="false">
        <v-alert outlined icon="mdi-alert" color="orange darken-2"
          ><h3>
            Fecha de consulta: {{ rangoFechas }} y fecha de comparación
            {{ rangoFechasComparar }}
          </h3></v-alert
        >
      </v-col>
      <v-col cols="12" sm="6" lg="4" class="pb-0">
        <v-dialog
          ref="dialog"
          class="rounded-lg"
          v-model="dialogoCalendario"
          max-width="360px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              v-model="rangoFechas"
              label="Rango de fechas"
              append-icon="mdi-calendar"
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-card>
            <v-card-text class="pb-0">
              <v-select
                dense
                v-model="periodo"
                append-icon="mdi-calendar"
                label="Selecciona un período predeterminado"
                outlined
                :items="periodoItems"
              />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-date-picker
                v-model="fechas"
                :return-value.sync="fechas"
                full-width
                range
                value="dd-mm-YYYY"
                :first-day-of-week="1"
                locale="es-es"
                no-title
                show-current
              >
              </v-date-picker>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="mr-0"
                @click="verDatos"
                :disabled="!fechaValida"
                :loading="loadingEstadisticas"
                >Ver
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" lg="4" class="pb-0">
        <v-dialog
          ref="dialog"
          class="rounded-lg"
          v-model="dialogoCalendarioComparar"
          max-width="360px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              v-model="rangoFechasComparar"
              label="Rango de fechas comparar"
              append-icon="mdi-calendar"
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-card>
            <v-card-text class="pb-0">
              <v-select
                dense
                v-model="periodoComparar"
                append-icon="mdi-calendar"
                label="Selecciona un período predeterminado comparar"
                outlined
                :items="periodoItems"
              />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-date-picker
                v-model="fechasComparar"
                :return-value.sync="fechasComparar"
                full-width
                range
                value="dd-mm-YYYY"
                :first-day-of-week="1"
                locale="es-es"
                no-title
                show-current
              >
              </v-date-picker>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="mr-0"
                @click="verDatos"
                :disabled="!fechaValidaComparar"
                :loading="loadingEstadisticas"
                >Ver
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="5" sm="6" lg="4" class="text-right pl-0" v-if="viendoDatos">
        <!--viendoDatos-->
        <div class="mt-sm-n2">
          <v-btn
            text
            fab
            :small="$vuetify.breakpoint.xs"
            color="rgba(0, 0, 0, 0.54)"
            @click="
              filtrosAcordeon == null
                ? (filtrosAcordeon = 0)
                : (filtrosAcordeon = null)
            "
          >
            <div class="d-flex flex-column align-center">
              <v-icon>mdi-filter</v-icon>
              <p class="mb-0 text-caption">Filtros</p>
            </div>
          </v-btn>
          <v-btn
            text
            fab
            :small="$vuetify.breakpoint.xs"
            @click="descargar"
            :loading="descargarLoading"
            color="rgba(0, 0, 0, 0.54)"
            class="ml-6 ml-sm-4"
          >
            <div class="d-flex flex-column align-center">
              <v-icon>mdi-download</v-icon>
              <p class="mb-0 text-caption">Descargar</p>
            </div>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-expansion-panels v-model="filtrosAcordeon" popout>
      <v-expansion-panel>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="4">
              <v-select
                dense
                label="Canal venta"
                multiple
                :items="$store.state.estadisticas.filtros.canalVenta"
                v-model="filtrosEleccion.canalVenta"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-if="role === 'admin'"
                clearable
                dense
                label="Negocios"
                multiple
                :items="negociosFiltradosTodos"
                v-model="filtrosEleccion.negocios"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                dense
                clearable
                label="Restaurante"
                multiple
                :items="restaurantesFiltradosTodos"
                v-model="filtrosEleccion.restaurantes"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                dense
                v-model="filtrosEleccion.modo"
                multiple
                :items="$store.state.estadisticas.filtros.modo"
                label="Modo"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                dense
                clearable
                v-model="filtrosEleccion.formaPago"
                multiple
                :items="$store.state.estadisticas.filtros.formaPago"
                label="Forma Pago"
              />
            </v-col>
            <v-col cols="12" sm="2">
              <v-checkbox
                dense
                v-model="filtrosEleccion.showEliminados"
                label="Mostrar eliminados"
                class="mt-0"
              />
            </v-col>
            <v-col cols="12" sm="2">
              <v-btn
                dense
                rounded
                outlined
                @click="verDatos"
                color="primary"
                :loading="loadingEstadisticas"
                >Aplicar</v-btn
              >
            </v-col>
          </v-row>
          <!-- <v-row class="mb-4 mt-0">
            <v-col cols="12" class="text-center">
              <v-btn small color="primary">
                Aplicar
              </v-btn>
            </v-col>
          </v-row> -->
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-divider v-if="filtrosAcordeon != null" class="my-3" />
    <template v-if="viendoDatos">
      <v-row>
        <v-col cols="12" sm="5" md="4">
          <base-material-stats-card
            color="info"
            icon="mdi-shopping"
            title="pedidos"
            :value="pedidosNumero"
            sub-icon="mdi-clock"
            sub-text="Total de pedidos hoy"
            class="mb-4"
          />
          <base-material-stats-card
            color="success"
            icon="mdi-currency-eur"
            title="Total facturado"
            :value="pedidosCantidad"
            sub-icon="mdi-clock"
            sub-text="Total de beneficios hoy"
            class="mb-4"
          />
        </v-col>

        <v-col cols="12" sm="7" md="8">
          <grafico-lineas
            key="graficoPedidos"
            :chartData="chartDataPedidosHoras"
            :options="chartOptionsNumPedidos"
          />
          <!-- <base-material-chart-card
            :data="pedidosPorHora"
            :options="colouredLine.options"
            type="Line"
            color="secondary"
            sub-icon="mdi-clock"
            sub-text="Desglose por horas"
          >
            <template>
              <h2 class="title">Desglose ventas por hora</h2>
              <p class="category">
                <span class="">
                  <v-icon small>mdi-arrow-top-right</v-icon> 55%
                </span>
                de aumento en las ventas hoy.
              </p>
            </template>
          </base-material-chart-card> -->
        </v-col>
      </v-row>
    </template>
    <template v-if="viendoDatos">
      <v-divider class="my-8" />
      <v-row>
        <v-col cols="12" sm="6" lg="4">
          <grafico-rosco
            :chartData="chartDataFormaPago"
            :options="chartOptionsFormaPago"
          />
          <v-divider class="mt-12 mb-5 d-sm-none" />
        </v-col>
        <v-col cols="12" sm="6" lg="4">
          <grafico-rosco
            :chartData="chartDataModo"
            :options="chartOptionsModo"
          />
          <v-divider class="mt-12 mb-5 d-sm-none" />
        </v-col>
        <v-col cols="12" sm="6" lg="4">
          <grafico-lineas
            :chartData="chartDataPedidosDias"
            :options="chartOptionsNumPedidos"
          />
        </v-col>
      </v-row>
      <v-divider class="my-8" />
      <v-row class="mx-n8 mx-md-0">
        <v-col cols="12" lg="6" v-if="role == 'admin'">
          <h3 class="mx-4 mb-4 mx-md-0">NEGOCIOS</h3>
          <v-data-table
            :headers="headers"
            :items="pedidosAgrupados.negocio"
            sort-by="total"
            :sort-desc="true"
            :class="$vuetify.breakpoint.mdAndUp ? 'elevation-2' : ''"
          >
            <template v-slot:item.total="{ item }">
              <v-chip color="success">
                {{ item.total }}
              </v-chip>
            </template>
            <template v-slot:item.visible="{ item }" class="text-center">
              <v-simple-checkbox
                v-model="item.visible"
                :ripple="false"
              ></v-simple-checkbox>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="12" lg="6">
          <h3 class="mx-4 mb-4 mx-md-0">RESTAURANTES</h3>
          <v-data-table
            :headers="headers"
            :items="pedidosAgrupados.rest"
            sort-by="total"
            :sort-desc="true"
            :class="$vuetify.breakpoint.mdAndUp ? 'elevation-2' : ''"
          >
            <template v-slot:item.total="{ item }">
              <v-chip color="success">
                {{ item.total }}
              </v-chip>
            </template>
            <template v-slot:item.totalPorcentaje="{ item }">
              {{ item.totalPorcentaje.toFixed(2) }} %
            </template>
            <template v-slot:item.numPedidosPorcentaje="{ item }">
              {{ item.numPedidosPorcentaje.toFixed(2) }} %
            </template>
            <template v-slot:item.visible="{ item }" class="text-center">
              <v-simple-checkbox
                v-model="item.visible"
                :ripple="false"
              ></v-simple-checkbox>
            </template>
          </v-data-table>
        </v-col>
        <v-row class="mx-n8 mx-md-0" justify="center">
          <v-col class="mt-3" cols="12">
            <h2 class="mx-4 mb-4 mx-md-0 text-center">PRODUCTOS</h2></v-col
          >
          <v-col cols="12" lg="4">
            <template>
              <v-data-table
                :headers="headersPlatos"
                :items="pedidosAgrupados.platos"
                class="elevation-2"
              >
                <template v-slot:item.total="{ item }">
                  <v-chip color="success"> {{ item.total }} € </v-chip>
                </template>
              </v-data-table>
            </template>
          </v-col>
          <v-col cols="12" lg="8">
            <categorias-productos-barra
              key="graficoProductos"
              :chartData="barraDataProductos"
              :options="barrasProductosOptions"
            />
          </v-col>
        </v-row>
      </v-row>
    </template>
  </div>
</template>
<script>
import moment from "moment-timezone";
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda } from "@/utils/utils.js";
import GraficoLineas from "./base/GraficoLineas.vue";
import { restSinNegocio } from "@/utils/restaurantes.utils.js";
import GraficoRosco from "./base/GraficoRosco.vue";
import CategoriasProductosBarra from "./base/CategoriasProductosBarra.vue";
import jsPDF from "jspdf";
import XLSX from "xlsx";

export default {
  components: { GraficoLineas, GraficoRosco, CategoriasProductosBarra },
  data() {
    return {
      loadingEstadisticas: false,
      periodo: "personalizado",
      periodoComparar: "personalizado",
      filtrosAcordeon: null,
      filtrosEleccion: {
        canalVenta: ["propio", "directorio", "tpv"],
        formaPago: [],
        showEliminados: false,
        negocios: [],
        restaurantes: [],
        modo: [],
      },
      chartOptionsNumPedidos: {
        tooltips: {
          mode: "index",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: "index",
          intersect: true,
        },
        stacked: false,
        grid: {
          drawOnChartArea: false, // only want the grid lines for one axis to show up
        },
        scales: {
          yAxes: [
            {
              id: "y-axis-1",
              title: {
                display: true,
                text: "Total",
                align: "center",
              },
              ticks: {
                padding: 25,
              },
            },
            {
              id: "y-axis-2",
              title: {
                display: true,
                text: "Total",
                align: "center",
              },
              position: "right",
            },
          ],
        },
      },
      chartOptionsFormaPago: {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom",
          },
          title: {
            display: true,
            text: "Formas de pago",
          },
        },
      },
      chartOptionsModo: {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom",
          },
          title: {
            display: true,
            text: "Modo",
          },
        },
      },
      barrasProductosOptions: {
        scales: {
          yAxes: [
            {
              id: "cantidad",
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
            {
              position: "right",
              id: "total",
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function (tooltipItems, data) {
              return tooltipItems.yLabel + " €";
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
      ///cambiar
      dialogoAlert: false,
      dialogoCalendario: false,
      dialogoCalendarioComparar: false,

      listaRestaurantes: [],
      listaTiposPedidos: [],
      listaCategorias: [],

      tipoPedidos: ["A domicilio", "Recoger"],

      headers: [
        {
          text: "Nombre",
          align: "start",
          sortable: false,
          value: "nombre",
        },
        { text: "Total ventas", value: "total" },
        { text: "Porcentaje ventas", value: "totalPorcentaje" },
        { text: "Número pedidos", value: "numPedidos" },
        { text: "Porcentaje pedidos", value: "numPedidosPorcentaje" },
        // { text: "Recogidas", value: "recogidas" },
        // { text: "Visible en estadísticas", value: "visible" },
      ],
      headersPlatos: [
        {
          text: "Plato/Categoría",
          align: "start",
          sortable: false,
          value: "nombre",
        },
        { text: "Cantidad", value: "cantidad" },

        { text: "Total", value: "total" },
      ],

      fechas: [],
      fechasComparar: [],
      descargarLoading: false,
    };
  },
  watch: {
    periodo(v) {
      console.log(v);
      if (Array.isArray(v) && v.length >= 2) {
        this.fechas = [v[0], v[1]];
      }
    },
    periodoComparar(v) {
      console.log(v);
      if (Array.isArray(v) && v.length >= 2) {
        this.fechasComparar = [v[0], v[1]];

        // this.fechasComparar = v;
      }
    },
    fechas(v) {
      if (v.length === 2) {
        this.periodo = "personalizado";
        this.fechaInicio = v[0];
        this.fechaFin = v[1];
      }
    },
    fechaFin(v) {
      console.log(this.fechas);
      let momentInicio = moment
        .tz(this.fechas[0], "YYYY-MM-DD", "Europe/Madrid")
        .hour(this.$store.state.horaInicio);
      let momentFin = moment
        .tz(this.fechas[1], "YYYY-MM-DD", "Europe/Madrid")
        // .add(1, "day")
        .hour(this.$store.state.horaInicio);
      var duration = moment.duration(
        momentFin.clone().add(1, "day").diff(momentInicio)
      );
      this.fechasComparar = [
        momentInicio.clone().subtract(duration).format("YYYY-MM-DD"),
        momentFin.clone().subtract(duration).format("YYYY-MM-DD"),
      ];
      console.log("cierraPeriodo");
      console.log(duration.asDays());
      let dias = duration.asDays();
      console.log([
        momentInicio.clone().subtract(dias, "days").format("YYYY-MM-DD"),
        momentFin
          .clone()
          .subtract(dias, "days")
          // .subtract(1, "day")
          .format("YYYY-MM-DD"),
      ]);
    },
    fechasComparar(v) {
      if (v.length === 2) {
        this.periodoComparar = "personalizado";
        this.fechaInicioComparar = v[0];
        this.fechaFinComparar = v[1];
      }
    },
  },
  computed: {
    ...mapGetters({
      role: "auth/role",
    }),
    periodoItems() {
      let currentYear = moment()
        .subtract(1, "year")
        .endOf("year")
        .format("YYYY");
      return [
        { text: "Personalizado", value: "personalizado" },
        {
          text: "La semana pasada",
          value: [
            moment()
              .subtract(1, "week")
              .startOf("isoWeek")
              .format("YYYY-MM-DD"),
            moment().subtract(1, "week").endOf("isoWeek").format("YYYY-MM-DD"),
          ],
        },
        {
          text: "Esta semana",
          value: [
            moment()
              .tz("Europe/Madrid")
              .startOf("isoWeek")
              .format("YYYY-MM-DD"),
            moment().tz("Europe/Madrid").endOf("day").format("YYYY-MM-DD"),
          ],
        },
        {
          text:
            "El mes pasado (" +
            moment().subtract(1, "month").endOf("month").format("MMMM") +
            " de " +
            moment().subtract(1, "month").endOf("day").format("YYYY") +
            ")",
          value: [
            moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
            moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
            moment().subtract(1, "month").endOf("month").format("MMMM") +
              " de " +
              moment().subtract(1, "month").endOf("day").format("YYYY"),
          ],
        },
        {
          text:
            "Este mes (" +
            moment().tz("Europe/Madrid").endOf("day").format("MMMM") +
            " de " +
            moment().tz("Europe/Madrid").endOf("day").format("YYYY") +
            ")",
          value: [
            moment().tz("Europe/Madrid").startOf("month").format("YYYY-MM-DD"),
            moment().tz("Europe/Madrid").endOf("day").format("YYYY-MM-DD"),
            moment().tz("Europe/Madrid").endOf("day").format("MMMM") +
              " de " +
              moment().tz("Europe/Madrid").endOf("day").format("YYYY"),
          ],
        },
        {
          text: "Este año",
          value: [
            moment().startOf("year").format("YYYY-MM-DD"),
            moment().endOf("day").format("YYYY-MM-DD"),
            moment().endOf("day").format("YYYY"),
          ],
        },
        {
          text:
            "Año pasado (" +
            moment().subtract(1, "year").endOf("year").format("YYYY") +
            ")",
          value: [
            moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD"),
            moment().subtract(1, "year").endOf("year").format("YYYY-MM-DD"),
            "AÑO " + currentYear,
          ],
        },
      ];
    },
    restaurantesFiltradosTodos() {
      //this.pedido[0] días semana
      //this.pedido[1] horas
      //this.pedido[2] restaurante
      //this.pedido[3] negocios
      //this.pedido[4] modo
      //this.pedido[5] forma pago
      //this.pedido[6] total
      const restaurantesTodos =
        this.role === "boss_negocio"
          ? this.$store.state.restaurantes.restaurantesArray
          : this.$store.state.restaurantes.restaurantesTodosArray.filter(
              (r) => {
                return (
                  this.filtrosEleccion.negocios.length == 0 ||
                  this.filtrosEleccion.negocios.includes(r.negocio)
                );
              }
            );
      let res = (
        this.pedidos && this.pedidos[2]
          ? restaurantesTodos.map((r) => {
              let fR;
              let fN;
              var nombre = false;
              if (this.role === "boss_negocio") {
                fR = r; //compatibilidad
                nombre = fR ? fR.nombre : false;
              } else if (this.role === "admin") {
                console.log(r);
                fR = r;
                fN = fR
                  ? this.$store.state.negocios.negociosArray.find(
                      (n) => n.id === fR.negocio
                    )
                  : false;
                nombre = fR && fN ? fN.nombre + " " + fR.nombre : false;
              }
              return nombre ? { text: nombre, value: r.id } : "";
            })
          : []
      ).sort(function (a, b) {
        if (a.value < b.value) {
          return -1;
        }
        if (a.value > b.value) {
          return 1;
        }
        return 0;
      });
      console.log(res);
      return res;
      return this.pedidos[2].map((p) => {
        let f = p.NEGOCIO + "-" + p.RESTAURANTE;
        let found = this.$store.state.restaurantes.restaurantesTodosArray.find(
          (r) => r.id == f
        );
        let foundNegocio = this.$store.state.negocios.negociosArray.find(
          (n) => n.id == p.NEGOCIO
        );
        // console.log(found);
        // console.log(foundNegocio);
        return {
          text:
            found && foundNegocio
              ? foundNegocio.nombre + " " + found.nombre
              : f,
          value: f,
        };
      });
    },
    negociosFiltradosTodos() {
      return this.$store.state.negocios.negociosArray.map((n) => {
        return {
          text: n.nombre,
          value: n.id,
        };
      });
      return this.pedidos.map((p) => {
        let f = p.NEGOCIO;
        let found = this.$store.state.negocios.negociosArray.find(
          (r) => r.id == f
        );
        // console.log(found);
        // console.log(foundNegocio);
      });
    },
    chartDataFormaPago() {
      return {
        labels: this.$store.state.estadisticas.filtros.formaPago.map(
          (f) => f.text
        ),
        datasets: [
          {
            label: "Pedidos",
            data: this.pedidosAgrupados.formaPago.map((f) => f.numPedidos),
            backgroundColor: ["red", "orange", "yellow", "green"],
          },
          {
            label: "Total",
            data: this.pedidosAgrupados.formaPago.map((f) => f.total),
            backgroundColor: ["red", "orange", "yellow", "green"],
          },
        ],
      };
    },
    chartDataModo() {
      return {
        labels: this.$store.state.estadisticas.filtros.modo.map((f) => f.text),
        datasets: [
          {
            label: "Pedidos",
            data: this.pedidosAgrupados.modo.map((f) => f.numPedidos),
            backgroundColor: ["blue", "pink"],
          },
          {
            label: "Total",
            data: this.pedidosAgrupados.modo.map((f) => f.total),
            backgroundColor: ["blue", "pink"],
          },
        ],
      };
    },
    barraDataProductos() {
      return {
        labels: this.pedidosAgrupados.platos.map((p) => p.nombre),
        datasets: [
          {
            yAxisID: "cantidad",
            label: "Número",
            backgroundColor: "#f87979",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.pedidosAgrupados.platos.map((p) => p.cantidad),
          },
          {
            yAxisID: "total",

            label: "Total",
            backgroundColor: "#249EBF",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#f87979",
            data: this.pedidosAgrupados.platos.map((p) => p.total),
          },
        ],
      };
    },
    chartDataPedidosHoras() {
      return {
        labels: this.pedidosPorHoraLabels,
        datasets: [
          {
            label: "Número pedidos",
            backgroundColor: "rgba(0, 0, 0, 0.1)", //this.$vuetify.theme.defaults.light.secondary,
            borderColor: this.$vuetify.theme.defaults.light.secondary,
            data: this.pedidosPorHoraDatos,
            clip: 0,
            // lineTension: 0,

            // yAxisID: "y",
            yAxisID: "y-axis-1",
          },
          {
            label: "Total",
            backgroundColor: "rgba(0, 0, 0, 0.1)", //this.$vuetify.theme.defaults.light.primary,
            borderColor: this.$vuetify.theme.defaults.light.primary,

            data: this.pedidosPorHoraTotalDatos,
            yAxisID: "y-axis-2",
          },
        ],
      };
    },
    chartDataPedidosDias() {
      return {
        labels: this.pedidosPorDiaLabels,
        datasets: [
          {
            label: "Número pedidos",
            backgroundColor: "rgba(0, 0, 0, 0.1)", //this.$vuetify.theme.defaults.light.secondary,
            borderColor: this.$vuetify.theme.defaults.light.secondary,
            data: this.pedidosPorDiaDatos,
            clip: 0,
            // lineTension: 0,

            // yAxisID: "y",
            yAxisID: "y-axis-1",
          },
          {
            label: "Total",
            backgroundColor: "rgba(0, 0, 0, 0.1)", //this.$vuetify.theme.defaults.light.primary,
            borderColor: this.$vuetify.theme.defaults.light.primary,

            data: this.pedidosPorDiaTotalDatos,
            yAxisID: "y-axis-2",
          },
        ],
      };
    },
    altoPedidosHoras() {
      return Math.max.apply(
        Math,
        this.pedidosPorHora.map(function (o) {
          return o.numPedidos;
        })
      );
    },
    altoPedidosDiaSemana() {
      return Math.max.apply(
        Math,
        this.pedidosPorDiaSemana.map(function (o) {
          return o.numPedidos;
        })
      );
    },
    pedidosPorHoraDatos() {
      return this.pedidosAgrupados.horas.map((h) => h.numPedidos);
    },
    pedidosPorHoraTotalDatos() {
      return this.pedidosAgrupados.horas.map((h) => h.total);
    },
    pedidosPorHoraLabels() {
      return this.pedidosAgrupados.horas.map((h) => h.hora.toString() + "h");
    },
    pedidosPorDiaDatos() {
      return this.pedidosAgrupados.diasSemana.map((h) => h.numPedidos);
    },
    pedidosPorDiaTotalDatos() {
      return this.pedidosAgrupados.diasSemana.map((h) => h.total);
    },
    pedidosPorDiaLabels() {
      return this.diasSemana.map((h) => h.text);
    },

    diasSemana() {
      return [
        { text: "Lunes", value: 1 },
        { text: "Martes", value: 2 },
        { text: "Miércoles", value: 3 },
        { text: "Jueves", value: 4 },
        { text: "Viernes", value: 5 },
        { text: "Sábado", value: 6 },
        { text: "Domingo", value: 7 },
      ];
    },
    horasPedidos() {
      return [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    },
    horasPedidosLabel() {
      return this.horasPedidos.map((h) => h.toString() + "h");
    },
    // fechas: {
    //   get() {
    //     return this.fechaInicio && this.fechaFina
    //       ? [this.fechaInicio, this.fechaFin]
    //       : [];
    //   },
    //   set(v) {
    //     console.log(v);
    //     if (!!v[0]) this.fechaInicio = v[0];
    //     if (!!v[1]) this.fechaFin = v[1];
    //   },
    // },
    fechaInicio: {
      get() {
        return this.$store.state.estadisticas.rango.inicio;
      },
      set(v) {
        console.log(v);
        this.$store.commit("estadisticas/setRangoKey", {
          key: "inicio",
          value: v,
        });
      },
    },
    fechaFin: {
      get() {
        return this.$store.state.estadisticas.rango.fin;
      },
      set(v) {
        this.$store.commit("estadisticas/setRangoKey", {
          key: "fin",
          value: v,
        });
      },
    },
    fechaInicioComparar: {
      get() {
        return this.$store.state.estadisticas.rangoComparar.inicio;
      },
      set(v) {
        this.$store.commit("estadisticas/setRangoCompararKey", {
          key: "inicio",
          value: v,
        });
      },
    },
    fechaFinComparar: {
      get() {
        return this.$store.state.estadisticas.rangoComparar.fin;
      },
      set(v) {
        this.$store.commit("estadisticas/setRangoCompararKey", {
          key: "fin",
          value: v,
        });
      },
    },
    pedidosNumero() {
      return this.pedidosAgrupados.pedidos.NUM_PEDIDOS.toString();
    },
    pedidosCantidad() {
      return mostrarMoneda(this.pedidosAgrupados.pedidos.TOTAL);
    },
    pedidosAgrupados() {
      //this.pedidos [0] por dia de semana
      //this.pedidos[1] por hora
      //this.pedidos[2] totales

      console.log(this.pedidos);
      var agrupadosRest = [];
      var agrupadosNegocio = [];

      var diasSemana = this.diasSemana.map((d) => {
        let f = this.pedidos[0].find((dP) => {
          let dComparar = dP.DIA_SEMANA == 1 ? 7 : dP.DIA_SEMANA - 1;
          return dComparar == d.value;
        });
        if (f) {
          return {
            diaSemana: d.value,
            numPedidos: f.NUM_PEDIDOS,
            total: mostrarMoneda(f.TOTAL),
          };
        } else {
          return {
            diaSemana: d.value,
            numPedidos: 0,
            total: mostrarMoneda(0),
          };
        }
      });
      var modo = this.$store.state.estadisticas.filtros.modo.map((m) => {
        let f = this.pedidos[4].find((dP) => {
          let dComparar = dP.MODO;
          return dComparar == m.value;
        });
        if (f) {
          return {
            modo: m.value,
            numPedidos: f.NUM_PEDIDOS,
            total: mostrarMoneda(f.TOTAL),
          };
        } else {
          return {
            modo: m.value,
            numPedidos: 0,
            total: mostrarMoneda(0),
          };
        }
      });
      var formaPago = JSON.parse(
        JSON.stringify(this.$store.state.estadisticas.filtros.formaPago)
      ).map((m) => {
        let f = this.pedidos[5].find((dP) => {
          if (m.value == "tarjeta_online") {
            return (
              dP.FORMA_PAGO == "tarjeta_online" ||
              dP.FORMA_PAGO == "tarjeta_online_multiple"
            );
          } else {
            let dComparar = dP.FORMA_PAGO;
            return dComparar == m.value;
          }
        });
        if (f) {
          return {
            modo: m.value,
            numPedidos: f.NUM_PEDIDOS,
            total: mostrarMoneda(f.TOTAL),
            nombre: m.text,
          };
        } else {
          return {
            modo: m.value,
            numPedidos: 0,
            nombre: m.text,

            total: mostrarMoneda(0),
          };
        }
      });

      var modoRest = this.pedidos[7]
        .map((modo) => {
          console.log(modo);
          let f = this.$store.state.estadisticas.filtros.modo.find(
            (dP) => dP.value == modo.MODO
          );
          if (f) {
            return {
              modo: f.text,
              restaurante: modo.RESTAURANTE,
              numPedidos: modo.NUM_PEDIDOS,
              total: mostrarMoneda(modo.TOTAL),
            };
          }
        })
        .filter((m) => !!m);

      var modoPersonalizadoRest = this.pedidos[8]
        .map((modo) => {
          return {
            modo: modo.MODO_PERSONALIZADO,
            restaurante: modo.RESTAURANTE,
            numPedidos: modo.NUM_PEDIDOS,
            total: mostrarMoneda(modo.TOTAL),
          };
        })
        .filter((m) => !!m);

      var formaPagoRest = this.pedidos[9]
        .map((forma) => {
          let f = this.$store.state.estadisticas.filtros.formaPago.find(
            (fP) => fP.value == forma.FORMA_PAGO
          );
          return {
            nombre: !!f ? f.text : forma.FORMA_PAGO,
            // nombre: forma.FORMA_PAGO,
            modo: forma.FORMA_PAGO,
            restaurante: forma.RESTAURANTE,
            numPedidos: forma.NUM_PEDIDOS,
            total: mostrarMoneda(forma.TOTAL),
          };
        })
        .filter((m) => !!m);

      console.log(this.pedidos[11]);
      var platos = this.pedidos[11]
        .map((prd) => {
          return {
            nombre: prd.NOMBRE,
            // nombre: forma.FORMA_PAGO,

            restaurante: prd.RESTAURANTE,
            cantidad: prd.CANTIDAD,
            total: mostrarMoneda(prd.TOTAL),
          };
        })
        .filter((m) => !!m);

      var horas = this.horasPedidos.map((h) => {
        let f = this.pedidos[1].find((p) => {
          return moment(p.HORA.value, "HH:mm:ss").hour() == h;
        });
        return {
          hora: h,
          numPedidos: f ? f.NUM_PEDIDOS : 0,
          total: f ? mostrarMoneda(f.TOTAL) : 0,
        };
      });

      return {
        pedidos: {
          ...this.pedidos[6][0],
          TOTAL: mostrarMoneda(this.pedidos[6][0].TOTAL),
        },
        formaPago: formaPago,
        rest: this.pedidos[2].map((p) => {
          let fRest = this.$store.state.restaurantes.restaurantesArray.find(
            (r) => r.id == p.RESTAURANTE
          );
          let nombreNegocio =
            this.$store.getters["auth/role"] == "boss_directorio"
              ? this.$store.state.app.directorioObjGest.nombre
              : this.$store.getters["auth/role"] != "admin"
              ? this.$store.state.app.negocioObjGest.nombre
              : "";
          return {
            ...p,
            nombre:
              !!fRest && this.$store.getters["auth/role"] != "admin"
                ? nombreNegocio + " " + fRest.nombre
                : p.RESTAURANTE,
            numPedidos: p.NUM_PEDIDOS,
            numPedidosPorcentaje:
              (p.NUM_PEDIDOS / this.pedidos[6][0].NUM_PEDIDOS) * 100,
            total: mostrarMoneda(p.TOTAL),
            impuestos: mostrarMoneda(p.IMPUESTOS),
            totalPorcentaje: (p.TOTAL / this.pedidos[6][0].TOTAL) * 100,
          };
        }),
        negocio: this.pedidos[3].map((p) => {
          return {
            ...p,
            nombre: p.NEGOCIO,
            numPedidos: p.NUM_PEDIDOS,
            total: mostrarMoneda(p.TOTAL),
          };
        }),
        diasSemana: diasSemana,

        horas: horas,
        modo: modo,
        modoRest: modoRest,
        modoPersonalizadoRest: modoPersonalizadoRest,
        formaPagoRest: formaPagoRest,
        platos: platos,
      };
    },
    pedidosAgrupadosOld() {
      var agrupadosRest = [];
      var agrupadosNegocio = [];
      var agrupadosFormaPago =
        this.$store.state.estadisticas.filtros.formaPago.map((f) => {
          return {
            forma: f.value,
            numPedidos: 0,
            total: 0,
          };
        });
      var agrupadosModo = this.$store.state.estadisticas.filtros.modo.map(
        (f) => {
          return {
            modo: f.value,
            numPedidos: 0,
            total: 0,
          };
        }
      );
      var diasSemana = this.diasSemana.map((d) => {
        return {
          dia: d.value,
          numPedidos: 0,
          total: 0,
        };
      });
      var horas = this.horasPedidos.map((h) => {
        return {
          hora: h,
          numPedidos: 0,
          total: 0,
        };
      });

      let res = this.pedidos.filter((p) => {
        var bool = true;
        if (!this.filtrosEleccion.showEliminados) {
          bool = bool && p.ELIMINADO != true;
        }
        if (this.filtrosEleccion.negocios.length > 0) {
          bool = bool && this.filtrosEleccion.negocios.includes(p.NEGOCIO);
        }
        if (this.filtrosEleccion.formaPago.length > 0) {
          bool = bool && this.filtrosEleccion.formaPago.includes(p.FORMA_PAGO);
        }
        if (this.filtrosEleccion.modo.length > 0) {
          bool = bool && this.filtrosEleccion.modo.includes(p.MODO);
        }
        if (this.filtrosEleccion.restaurantes.length > 0) {
          // console.log("dentro");
          // console.log(
          //   this.filtrosEleccion.restaurantes.includes(
          //     p.NEGOCIIO + "-" + p.RESTAURANTE
          //   )
          // );
          bool =
            bool &&
            this.filtrosEleccion.restaurantes.includes(
              p.NEGOCIO + "-" + p.RESTAURANTE
            );
        }
        //p.modo =
        return bool;
      });
      if (res.length == 0) {
        return {
          pedidos: [],
          formaPago: agrupadosFormaPago.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(0),
            };
          }),
          rest: agrupadosRest.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(0),
            };
          }),
          negocio: agrupadosNegocio.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(0),
            };
          }),
          diasSemana: diasSemana.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(0),
            };
          }),
          horas: horas.map((p) => {
            return {
              ...p,
              total: 0,
            };
          }),
          modo: agrupadosModo.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(0),
            };
          }),
        };
      } else {
        res.map((p, i) => {
          //forma pago
          var foundPago = agrupadosFormaPago.findIndex(
            (aF) => aF.forma == p.FORMA_PAGO
          );
          if (foundPago > -1) {
            agrupadosFormaPago[foundPago].numPedidos =
              agrupadosFormaPago[foundPago].numPedidos + 1;
            agrupadosFormaPago[foundPago].total =
              agrupadosFormaPago[foundPago].total + parseFloat(p.TOTAL);
          }
          //modo

          var foundModo = agrupadosModo.findIndex((aF) => aF.modo == p.MODO);
          if (foundModo > -1) {
            agrupadosModo[foundModo].numPedidos =
              agrupadosModo[foundModo].numPedidos + 1;
            agrupadosModo[foundModo].total =
              agrupadosModo[foundModo].total + parseFloat(p.TOTAL);
          }
          //reestaurante
          var foundIndex = agrupadosRest.findIndex(
            (r) => p.NEGOCIO + "-" + p.RESTAURANTE == r.id
          );
          if (foundIndex >= 0) {
            agrupadosRest[foundIndex].numPedidos =
              agrupadosRest[foundIndex].numPedidos + 1;
            agrupadosRest[foundIndex].total =
              agrupadosRest[foundIndex].total + parseFloat(p.TOTAL);
          } else {
            let idAux = p.NEGOCIO + "-" + p.RESTAURANTE;
            let f = this.restaurantesFiltradosTodos.find(
              (r) => r.value == idAux
            );
            agrupadosRest.push({
              nombre: f ? f.text : idAux,
              id: idAux,
              negocio: p.NEGOCIO,
              numPedidos: 1,
              total: parseFloat(p.TOTAL),
            });
          }
          //ahora en negocio
          var foundIndex = agrupadosNegocio.findIndex((r) => p.NEGOCIO == r.id);
          if (foundIndex >= 0) {
            agrupadosNegocio[foundIndex].numPedidos =
              agrupadosNegocio[foundIndex].numPedidos + 1;
            agrupadosNegocio[foundIndex].total =
              agrupadosNegocio[foundIndex].total + parseFloat(p.TOTAL);
          } else {
            let idAuxN = p.NEGOCIO;
            let fN = this.$store.state.negocios.negociosArray.find(
              (r) => r.id == idAuxN
            );
            agrupadosNegocio.push({
              nombre: fN ? fN.nombre : p.NEGOCIO,
              id: p.NEGOCIO,
              negocio: p.NEGOCIO,
              numPedidos: 1,
              total: parseFloat(p.TOTAL),
            });
          }
          //por día de la semana

          let tz =
            p.copyRest &&
            p.copyRest.confGeneral &&
            p.copyRest.confGeneral.zonaHoraria
              ? p.copyRest.confGeneral.zonaHoraria
              : "Europe/Madrid";
          let momentObj = moment.unix(p["FECHA"]).tz(tz);
          let dia = momentObj.format("E");
          let hora = momentObj.format("H");
          var foundIndexHora = horas.findIndex((h) => h.hora == hora);
          if (foundIndexHora > -1) {
            horas[foundIndexHora].numPedidos =
              horas[foundIndexHora].numPedidos + 1;
            horas[foundIndexHora].total =
              horas[foundIndexHora].total + parseFloat(p.TOTAL);
          }
          var foundIndexDia = diasSemana.findIndex((h) => h.dia == dia);
          if (foundIndexDia > -1) {
            diasSemana[foundIndexDia].numPedidos =
              diasSemana[foundIndexDia].numPedidos + 1;
            diasSemana[foundIndexDia].total =
              diasSemana[foundIndexDia].total + parseFloat(p.TOTAL);
          }
        });
        let dev = {
          formaPago: agrupadosFormaPago.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(p.total),
            };
          }),
          modo: agrupadosModo.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(p.total),
            };
          }),
          pedidos: res,
          rest: agrupadosRest.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(p.total),
            };
          }),
          negocio: agrupadosNegocio.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(p.total),
            };
          }),
          diasSemana: diasSemana.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(p.total),
            };
          }),
          horas: horas.map((p) => {
            return {
              ...p,
              total: mostrarMoneda(p.total),
            };
          }),
        };

        return dev;
      }
    },
    rangoFechasComparar() {
      var fechaInicioMoment = moment(String(this.fechaInicioComparar));
      var fechaFinMoment = moment(String(this.fechaFinComparar));
      if (fechaInicioMoment.isAfter(fechaFinMoment)) {
        this.dialogoAlert = true;
        this.fechas = [];
      } else if (fechaInicioMoment.isValid() && fechaFinMoment.isValid()) {
        return (
          fechaInicioMoment.format("DD/MM/YYYY") +
          " - " +
          fechaFinMoment.format("DD/MM/YYYY")
        );
      } else {
        return "Elija fecha";
      }
    },
    rangoFechas() {
      var fechaInicioMoment = moment(String(this.fechaInicio));
      var fechaFinMoment = moment(String(this.fechaFin));
      if (fechaInicioMoment.isAfter(fechaFinMoment)) {
        this.dialogoAlert = true;
        this.fechas = [];
      } else if (fechaInicioMoment.isValid() && fechaFinMoment.isValid()) {
        return (
          fechaInicioMoment.format("DD/MM/YYYY") +
          " - " +
          fechaFinMoment.format("DD/MM/YYYY")
        );
      } else {
        return "Elija fecha";
      }
    },
    viendoDatos() {
      return this.pedidos.length > 0; // true para mostrar los datos
      // return true
    },
    fechaValida() {
      return (
        this.fechaInicio.trim().length > 0 && this.fechaFin.trim().length > 0
      );
    },
    fechaValidaComparar() {
      return (
        this.fechaInicioComparar.trim().length > 0 &&
        this.fechaFinComparar.trim().length > 0
      );
    },
    ...mapState({
      pedidosBruto: (state) => state.estadisticas.pedidos,
      pedidosComparar: (state) => state.estadisticas.pedidosComparar,
      pedidosCompararBruto: (state) => state.estadisticas.pedidosComparar,
    }),
    pedidos: {
      get() {
        return this.pedidosBruto;
      },
      set(v) {
        this.$store.commit("estadisticas/setPedidos", v);
      },
    },
  },
  methods: {
    descargar() {
      this.descargarLoading = true;
      this.$store
        // .dispatch("estadisticas/exportarExcelBQ", this.pedidosAgrupados)
        .dispatch(
          "estadisticas/exportarExcelBQ",
          !!this.pedidosAgrupados
            ? {
                ...this.pedidosAgrupados,
                periodo: this.fechas,
                periodoComparar: this.fechasComparar,
              }
            : []
        )
        .then((r) => {
          console.log(r);
          window.open(r, "_blank");
        })
        .finally(() => (this.descargarLoading = false));
    },
    //DATOS ESTADÍSTICAS
    // 0: Totales día semana
    // 1: Totales hora
    // 2: Totales por restaurante
    // 3: Totales por negocio
    // 4: Totales por modo
    // 5: Totales por forma pago
    // 6: Totales total
    // 7: Por restaurante y modo
    // 8: Por restaurante y modo personalizado
    // 9: Por restaurante y forma pago
    // 10: Por restaurante y totales
    verDatos() {
      this.loadingEstadisticas = true;
      this.$store
        .dispatch("estadisticas/getEstadisticasBQ", {
          filtros: this.filtrosEleccion,
        })
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Datos descargados",
          });
          console.log(r);
          this.dialogoCalendario = false;
          this.dialogoCalendarioComparar = false;
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al generar estadísticas " + e,
          });
        })
        .finally(() => (this.loadingEstadisticas = false));
    },
    eliminarRestaurante(restaurante) {
      const index = this.listaRestaurantes.indexOf(restaurante.nombre);
      if (index >= 0) this.listaRestaurantes.splice(index, 1);
    },

    eliminarTipo(tipoPedido) {
      const index = this.listaTiposPedidos.indexOf(tipoPedido);
      if (index >= 0) this.listaTiposPedidos.splice(index, 1);
    },
  },
  mounted() {
    this.$store.dispatch("restaurantes/getTodosRestaurantes");
    if (this.fechaInicio.length > 0 && this.fechaFin.length > 0)
      this.fechas = [this.fechaInicio, this.fechaFin];
  },
};
</script>

<style scoped>
/*
      elimina el descuadre de los botones de navegación entre meses
      (se puede sacar a estilos generales porque parece un fallo del date-picker)
  */
.v-date-picker-header .v-btn {
  margin: 0 !important;
}
</style>